import { useTranslation } from '@/hooks/use-translation'
import { Main } from '@/components/layout/main'
import { UnifiedHeader } from '@/components/layout/unified-header'
import { GameRecordsTable } from './game-records-table'

export default function GameRecords() {
  const { t } = useTranslation()

  return (
    <>
      <UnifiedHeader />

      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>
              {t('gameRecords.gameRecords')}
            </h2>
            <p className='text-muted-foreground'>
              {t('gameRecords.manageGameRecordsHere')}
            </p>
          </div>
        </div>

        <div className='flex-1 overflow-auto'>
          <GameRecordsTable />
        </div>
      </Main>
    </>
  )
}
